let OSS = require('ali-oss');

let client = new OSS({
    region: 'oss-cn-beijing', //bucket所在的区域， 默认oss-cn-hangzhou。
    accessKeyId: 'LTAI5tJe2kdYYxor9xmu2Unm',  //通过阿里云控制台创建的AccessKey。
    accessKeySecret: 'JIVUO97blE63VGem0L0sVoCA2X3QCy',  //通过阿里云控制台创建的AccessSecret。
    bucket:'new-jnqg'  //通过控制台或PutBucket创建的bucket。
});
// 上传
export async function put (filePath, file) {
  try {
    let result = await client.put(filePath, file)
    return result
  } catch (err) {
  }
}

// 删除
export async function remove (filePath) {
  try {
    let result = await client.delete(filePath)
    return result
  } catch (err) {
  }
}
